"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExpenseType;
(function (ExpenseType) {
    ExpenseType[ExpenseType["Expense"] = 0] = "Expense";
    ExpenseType[ExpenseType["Credit"] = 1] = "Credit";
})(ExpenseType || (ExpenseType = {}));
exports.default = ExpenseType;
